import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=10b5463e"
import script from "./studentInfo.vue?vue&type=script&lang=js"
export * from "./studentInfo.vue?vue&type=script&lang=js"
import style0 from "./studentInfo.vue?vue&type=style&index=0&id=10b5463e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports